/* eslint-disable no-unused-vars */
import * as React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import LogoutIcon from "@mui/icons-material/Logout";
import logo from "Static/img/logo.svg";
import unCollapseLogo from "Static/img/updated_logo.svg";
import { icons } from "Static/utils/iconlist";
import variables from "Styles/variables.scss";
import Toolbar from "@mui/material/Toolbar";
import { useMutation, useQueryClient } from "react-query";

import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  Grid,
  List,
  Menu,
  Typography
} from "@mui/material";

import { useUserContext } from "Hooks/UserContext";
import {
  LogoutTypography,
  PUCAccordion,
  PUCAccordionDetails,
  PUCAccordionSummary,
  PUCAppBar,
  PUCAvatar,
  PUCBadge,
  PUCBasePopup,
  PUCChevronLeftIcon,
  PUCChevronRightIcon,
  PUCCollapseUserBox,
  PUCDrawer,
  PUCDrawerHeader,
  PUCKeyboardArrowDownIcon,
  PUCKeyboardArrowUpIcon,
  PUCList,
  PUCListCollapseTypography,
  PUCListLogoutCollapseTypography,
  PUCListLogoutTypography,
  PUCListTypography,
  PUCNotification,
  PUCTypography,
  PUCUserAccordion,
  PUCUserAppBar,
  PUCUserBottomAccordion,
  PUCUserBox,
  PUCUserCollapseDrawer,
  PUCUserDrawer,
  PUCUserDrawerHeader,
  PopupBody,
  RowGrid,
  PUCNotificationBar,
  PUCNotificationBarTypography,
  PUCNotificationBox,
  PUCNotificationContainer,
  PucButton,
  NotificationBox
} from "Helpers/overrides";
import { useQuery } from "react-query";

import { AccordionDetails } from "@mui/material";
import { UserMenuList } from "Static/utils/userMenuList";
import { useServices } from "Hooks/ServicesContext";
import { enqueueSnackbar } from "notistack";
import { snackBarErrorConf } from "Helpers/ats.constants";
import { Paths } from "Router/Paths";
import moment from "moment";

const Header = () => {
  const navigate = useNavigate();
  const popupRef = React.useRef();
  const queryClient = useQueryClient();
  const [open, setOpen] = React.useState(true);
  const { apiService } = useServices();
  const [notificationData, setNotificationData] = React.useState();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const nopen = Boolean(anchorEl);
  const nid = nopen ? "simple-popover" : undefined;
  const {
    setLoggedIn,
    userDetails,
    permission,
    setPermission,
    setuserDetails,
    profile,
    setProfile,
    notificationCount,
    setNotificatonCount
  } = useUserContext();
  const drawerStyle = {
    display: "flex",
    justifyContent: "flex-start",
    paddingLeft: "34px",
    minHeight: "65px !important"
  };
  const minHeightStyle = {
    minHeight: "65px !important"
  };
  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };
  const Logout = () => {
    window.localStorage.clear();
    setuserDetails(null);
    setLoggedIn(false);
    navigate(Paths.login);
    queryClient.removeQueries();
    queryClient.invalidateQueries();
  };
  const getIcon = (iconName, active) => {
    switch (iconName) {
      case "home":
        return active ? icons.Home.filled : icons.Home.regular;
      case "all_request":
        return active ? icons.AllRequest.filled : icons.AllRequest.regular;
      case "location_check":
        return active ? icons.Location_check.filled : icons.Location_check.regular;
      case "doc_verification":
        return active ? icons.DocVerification.filled : icons.DocVerification.regular;
      case "furniture_setup":
        return active ? icons.Furniture.filled : icons.Furniture.regular;
      case "deposit_check":
        return active ? icons.Deposit.filled : icons.Deposit.regular;
      case "material_dispatch":
        return active ? icons.Material_dispatch.filled : icons.Material_dispatch.regular;
      case "material_handover":
        return active ? icons.Material_handover.filled : icons.Material_handover.regular;

      case "manage_roles":
        return active ? icons.Manage_Roles.filled : icons.Manage_Roles.regular;
      case "manage_users":
        return active ? icons.Manage_Users.filled : icons.Manage_Users.regular;

      case "manage_banks":
        return active ? icons.Manage_bank.filled : icons.Manage_bank.regular;
      case "store":
        return active ? icons.Store.filled : icons.Store.regular;
      case "payment":
        return active ? icons.Payment.filled : icons.Payment.regular;
      case "display_wall":
        return active ? icons.Display_Wall.filled : icons.Display_Wall.regular;
      // Add more cases as needed for other icons
      default:
        return icons.Home.filled;
    }
  };
  //

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded((prevExpanded) => {
      if (isExpanded) {
        return [...prevExpanded, panel];
      } else {
        return prevExpanded.filter((p) => p !== panel);
      }
    });
  };
  const searchMenu = (menuItems, term, parent = null) => {
    for (const menuItem of menuItems) {
      if (menuItem.path === term) {
        // Return the matching parent item
        return menuItem;
      }

      if (menuItem.list && menuItem.list.length > 0) {
        // Recursively search in subMenu
        const result = searchMenu(menuItem.list, term, menuItem);

        // If the result is found in the subMenu, return it
        if (result) {
          return result;
        }
      }
    }

    // Return null if no match is found
    return null;
  };

  const [expanded, setExpanded] = React.useState(UserMenuList.map((item) => `panel${item.id}`));

  // Function to enable popup
  const handleProfile = (event) => {
    setProfile(profile ? null : event.currentTarget);
  };
  const profileOpen = Boolean(profile);

  const id = profileOpen ? "simple-popup" : undefined;
  const [logoutOpen, setLogoutOpen] = React.useState(false);

  // when click outside div then hide logout popup
  React.useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        setProfile(null); // Close the popup if clicked outside of it
      }
    };

    if (profileOpen) {
      // Attach the event listener when the popup is open
      document.addEventListener("click", handleClickOutside);
    }

    // Cleanup the event listener when component unmounts or popup closes
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [profileOpen]);

  // Calling notification API
  React.useEffect(() => {
    refetch();
  }, []);

  // fetch notification list data
  const { refetch } = useQuery("notificationData", () => apiService.getNotificationData(), {
    enabled: false,
    onSuccess: (data) => {
      setNotificationData(data);
      setNotificatonCount(data?.totalCount);
    }
  });

  // handle notification popup open and close
  const handleClick = (event) => {
    try {
      setAnchorEl(event.currentTarget);
      refetch(); // get notification update status list
    } catch (error) {}
  };

  // close to notification popup
  const handleClose = () => {
    try {
      setAnchorEl(null);
    } catch (error) {}
  };

  // redirect to notificatioin page
  const goToNotification = (type, ID, reqId, ref_id) => {
    try {
      updateNotificationStatus(ID); // Calling notification update api
      // Filter notification list according to staus
      const filterNotificationData = notificationData?.data?.filter((data) => {
        return data?.id !== ID;
      });
      // Update the state with filtered data
      setNotificationData((prevData) => ({
        ...prevData,
        data: filterNotificationData
      }));
      if (type === "payment-management"||type === "payment") {
        navigate(`/payment/view/${reqId}/${ref_id}`);
      } else if (type === "store") {
        navigate(`/${type}`);
      } else if (
        type === "all-request" ||
        type === "location-check" ||
        type === "doc-verfication" ||
        type === "deposit-check"
      ) {
        navigate(`/dashboard/view/${reqId}`);
      } else {
        navigate(`/${type}/view/${reqId}`);
      }
    } catch (error) {}
  };
  // Update notification API
  const { mutate: updateNotificationStatus } = useMutation(
    "updateNotificationStatus",
    // Function to fetch data of a single user using apiService.getRoleData
    (ID) => apiService.updateNotificationStatus(ID),
    {
      // Configuration options
      enabled: false, // Enable the query by default
      onSuccess: (data) => {
        if (data?.success) {
          setNotificatonCount((prev) => prev - 1);
        }
      }
    }
  );

  // Navigate to all notification page
  const handleViewAll = () => {
    try {
      navigate("/notification");
    } catch (error) {}
  };
  return (
    <>
      <PUCUserAppBar position="fixed" open={open}>
        <Toolbar
          sx={{
            display: "flex",
            justifyContent: "end",
            gap: "20px",
            marginRight: "14px"
          }}>
          {/* {open ? (
            <PUCChevronLeftIcon
              onClick={() => {
                handleDrawerClose();
              }}
            />
          ) : (
            <PUCChevronRightIcon
              onClick={() => {
                handleDrawerOpen();
              }}
            />
          )} */}

          <PUCBadge
            aria-describedby={nid}
            onClick={handleClick}
            badgeContent={notificationCount || 0}
            color="#EF6C00"
            sx={{ cursor: "pointer" }}>
            <PUCNotification />
          </PUCBadge>

          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              gap: "20px",
              marginRight: "14px"
            }}>
            {/* <PUCBadge badgeContent={4} color="#EF6C00">
              <PUCNotification />
            </PUCBadge> */}
            <Box
              sx={{
                display: "flex",

                overflowY: "auto",
                position: "relative"
              }}>
              <PUCAvatar aria-describedby={id} type="button" onClick={handleProfile}>
                {userDetails?.user_name?.slice(0, 1).toUpperCase()}
              </PUCAvatar>

              <PUCBasePopup id={id} open={profileOpen} anchor={profile}>
                <PopupBody ref={popupRef}>
                  <RowGrid item xs="8">
                    Name:&nbsp;<Typography variant="body1">{userDetails?.user_name}</Typography>
                  </RowGrid>
                  <RowGrid item xs="8">
                    ID:&nbsp;<Typography variant="body1">{userDetails?.ab_id}</Typography>
                  </RowGrid>
                  <RowGrid item xs="8">
                    Email:&nbsp;<Typography variant="body1">{userDetails?.user_email}</Typography>
                  </RowGrid>
                </PopupBody>
              </PUCBasePopup>
            </Box>
          </Box>
        </Toolbar>
      </PUCUserAppBar>
      {open ? (
        <PUCUserDrawer variant="permanent" open={open}>
          {open ? (
            <PUCUserDrawerHeader sx={drawerStyle}>
              <img
                src={unCollapseLogo}
                height={28}
                onClick={() => navigate("/dashboard")}
                style={{ cursor: "pointer" }}
              />
            </PUCUserDrawerHeader>
          ) : (
            ""
          )}
          {open ? (
            <PUCList
              sm={{
                paddingLeft: "0px 10px"
              }}>
              <PUCUserBox>
                {UserMenuList.filter((item) => item.isPublic).map((accordionItem, index) => (
                  <PUCUserAccordion
                    key={`list${index}`}
                    expanded={expanded.includes(`panel${accordionItem.id}`)}
                    onChange={handleChange(`panel${accordionItem.id}`)}>
                    <PUCAccordionSummary
                      // expandIcon={<ExpandMoreIcon />}
                      aria-controls={`panel${accordionItem.id}-content`}
                      id={`panel${accordionItem.id}-header`}>
                      <PUCTypography>
                        {accordionItem.title}{" "}
                        {expanded.includes(`panel${accordionItem.id}`) ? (
                          <PUCKeyboardArrowUpIcon />
                        ) : (
                          <PUCKeyboardArrowDownIcon />
                        )}
                      </PUCTypography>
                    </PUCAccordionSummary>
                    <PUCAccordionDetails>
                      {accordionItem.list.length > 0 &&
                        accordionItem.list.map((item, index) => {
                          return (
                            <>
                              {item?.type == "display_wall" && !userDetails?.store_code ? (
                                <></>
                              ) : (
                                <NavLink
                                  to={item.path}
                                  key={`sublist${index}`}
                                  activeclassname="active"
                                  style={{
                                    textDecoration: "none"
                                  }}>
                                  <PUCListTypography>
                                    <img
                                      src={getIcon(
                                        item.icon,
                                        window.location.pathname === item.path
                                      )}
                                    />{" "}
                                    {item.title}
                                  </PUCListTypography>
                                </NavLink>
                              )}
                            </>
                          );
                        })}
                    </PUCAccordionDetails>
                  </PUCUserAccordion>
                ))}

                <PUCUserBottomAccordion
                  key={`list${UserMenuList.length - 1}`}
                  expanded={expanded.includes(`panel${UserMenuList.length - 1}`)}
                  onChange={handleChange(`panel${UserMenuList.length - 1}`)}>
                  {/* <PUCAccordionSummary
                  // expandIcon={<ExpandMoreIcon />}
                  aria-controls={`panel${accordionItem.id}-content`}
                  id={`panel${accordionItem.id}-header`}>
                  <PUCTypography>{accordionItem.title}</PUCTypography>
                </PUCAccordionSummary> */}
                  <AccordionDetails
                    sx={{
                      padding: "0px 10px"
                    }}>
                    <Divider
                      sx={{
                        mt: 2,

                        borderColor: variables.grayColor
                      }}
                    />
                    <PUCListLogoutTypography
                      color={"error"}
                      variant="body2"
                      onClick={() => {
                        setLogoutOpen(true);
                        setProfile(null);
                      }}>
                      <LogoutIcon size={"small"} /> Log Out
                    </PUCListLogoutTypography>
                  </AccordionDetails>
                </PUCUserBottomAccordion>
              </PUCUserBox>
            </PUCList>
          ) : (
            ""
          )}
        </PUCUserDrawer>
      ) : (
        ""
      )}
      {!open ? (
        <PUCUserCollapseDrawer variant="permanent" open={open}>
          {!open ? (
            <PUCUserDrawerHeader sx={minHeightStyle}>
              <img src={logo} />
            </PUCUserDrawerHeader>
          ) : (
            ""
          )}
          <PUCList sx={{ padding: "0px" }}>
            <PUCCollapseUserBox>
              {UserMenuList.filter((item) => item.isPublic).map((accordionItem, index) => (
                <PUCAccordion
                  key={`list${index}`}
                  expanded={expanded.includes(`panel${accordionItem.id}`)}
                  onChange={handleChange(`panel${accordionItem.id}`)}>
                  {/* <PUCAccordionSummary
                  // expandIcon={<ExpandMoreIcon />}
                  aria-controls={`panel${accordionItem.id}-content`}
                  id={`panel${accordionItem.id}-header`}>
                  <PUCTypography>{accordionItem.title}</PUCTypography>
                </PUCAccordionSummary> */}
                  <AccordionDetails
                    sx={{
                      padding: "0px 10px"
                    }}>
                    {accordionItem.list.length > 0 &&
                      accordionItem.list.map((item, index) => {
                        return (
                          <NavLink
                            to={item.path}
                            key={`sublist${index}`}
                            activeclassname="active"
                            style={{
                              textDecoration: "none"
                            }}>
                            <PUCListCollapseTypography className="active" key={index} sx={{}}>
                              <img
                                src={getIcon(item.icon, window.location.pathname === item.path)}
                              />
                              {item.title}
                            </PUCListCollapseTypography>
                          </NavLink>
                        );
                      })}
                  </AccordionDetails>
                </PUCAccordion>
              ))}
              <PUCUserBottomAccordion
                key={`list${UserMenuList.length - 1}`}
                expanded={expanded.includes(`panel${UserMenuList.length - 1}`)}
                onChange={handleChange(`panel${UserMenuList.length - 1}`)}>
                {/* <PUCAccordionSummary
                  // expandIcon={<ExpandMoreIcon />}
                  aria-controls={`panel${accordionItem.id}-content`}
                  id={`panel${accordionItem.id}-header`}>
                  <PUCTypography>{accordionItem.title}</PUCTypography>
                </PUCAccordionSummary> */}
                <AccordionDetails
                  sx={{
                    padding: "0px 10px"
                  }}>
                  <PUCListLogoutCollapseTypography
                    color={"error"}
                    variant="body2"
                    onClick={() => {
                      setLogoutOpen(true);
                      setProfile(null);
                    }}>
                    <LogoutIcon size={"small"} /> Log Out
                  </PUCListLogoutCollapseTypography>
                </AccordionDetails>
              </PUCUserBottomAccordion>
            </PUCCollapseUserBox>
          </PUCList>
        </PUCUserCollapseDrawer>
      ) : (
        ""
      )}
      <Dialog fullWidth={true} open={logoutOpen} maxWidth={"xs"}>
        <DialogTitle id="responsive-dialog-title">Logout</DialogTitle>
        <DialogContent>
          <DialogContentText>Are you sure you want to logout?</DialogContentText>
        </DialogContent>

        <DialogActions>
          <Button
            onClick={() => {
              setLogoutOpen(false);
            }}
            color="inherit"
            variant="text"
            size="large">
            No
          </Button>
          <Button
            variant="contained"
            size="large"
            color="error"
            onClick={() => {
              Logout();
            }}>
            Yes
          </Button>
        </DialogActions>
      </Dialog>

      <PUCNotificationContainer>
        {/* {display && ( */}
        <>
          <Menu
            anchorEl={anchorEl}
            id="account-menu"
            open={nopen}
            onClose={handleClose}
            onClick={handleClose}
            PaperProps={{
              elevation: 0,
              sx: {
                overflow: "visible",
                // filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                mt: 1.5,
                "& .MuiAvatar-root": {
                  width: 32,
                  height: 32,
                  ml: -0.5,
                  mr: 1
                },
                "&::before": {
                  content: '""',
                  display: "block",
                  position: "absolute",
                  top: 0,
                  right: 14,
                  width: 10,
                  height: 10,
                  // bgcolor: "background.paper",
                  transform: "translateY(-50%) rotate(45deg)",
                  zIndex: 0
                }
              }
            }}
            transformOrigin={{ horizontal: "right", vertical: "top" }}
            anchorOrigin={{ horizontal: "right", vertical: "bottom" }}>
            <PUCNotificationBox>
              <PUCNotificationBar>
                <PUCNotificationBarTypography>{"Notifications"}</PUCNotificationBarTypography>
              </PUCNotificationBar>
              <NotificationBox>
                {notificationData?.data?.length > 0 ? (
                  notificationData?.data?.map((me, index) => (
                    <Box
                      key={index}
                      m={1}
                      whiteSpace={"pre"}
                      onClick={() =>
                        goToNotification(me?.type, me?.id, me?.req_id, me?.data?.reference_id)
                      }>
                      <Box sx={{ cursor: "pointer" }}>
                        {me.message.length > 50 ? me.message.slice(0, 50) + "...." : me.message}
                      </Box>
                      <Typography variant={"caption"} color="lightgrey">
                        {moment(me.created_at).fromNow()}
                      </Typography>
                    </Box>
                  ))
                ) : (
                  <Box m={1} mt={15} display={"flex"} justifyContent={"center"}>
                    <Box>No New Notification</Box>
                  </Box>
                )}
              </NotificationBox>
              <Box m={1} ml={0} mr={0} pr={1} display={"flex"} justifyContent={"flex-end"}>
                <PucButton variant={"contained"} onClick={handleViewAll}>
                  {"View all"}
                </PucButton>
              </Box>
            </PUCNotificationBox>
          </Menu>
        </>
        {/* )} */}
      </PUCNotificationContainer>
    </>
  );
};

export default Header;
